import { Component, Input } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
})
export class PasswordComponent {
  @Input() text = '';
  @Input() coverText = '点击查看密码';
  isVisible = false;

  constructor(private clipboard: Clipboard, private message: MessageService) {}

  copy() {
    this.clipboard.copy(this.text);
    this.message.open('已复制');
  }
}
